// Contact Form 
setTimeout(function() {
  jQuery("#shopify-block-AcFJ3WHBuTE05MlBNb__formful_app_block_form_AwgQQm")
    .insertAfter(".str-contact-form");
}, 100); 

// Acquisition Contact Form 
jQuery(document).ready(function ($) {
    $("div#shopify-block-AdFFGck8rUGIrSTBEd__formful_app_block_form_7CnNgH")
        .insertAfter(".acquisition-form");
});

// Continue Slider
document.addEventListener('DOMContentLoaded', function () {
  const sliderEl1 = document.getElementById('image-slider');

  if (sliderEl1) {
    const logoSlider = new Splide('#image-slider', {
      type: 'loop',
      autoWidth: true,
      arrows: false,
      pagination: false,
      drag: false,
      gap: '96px',
      autoScroll: {
        speed: 1,
        pauseOnHover: true,
        pauseOnFocus: true,
      },
      // Responsive breakpoints
      breakpoints: {
        1024: {
          gap: '60px',
          autoScroll: { speed: 0.8 },
        },
        767: {
          gap: '40px',
          autoScroll: { speed: 0.6 },
        },
        480: {
          gap: '50px',
          autoScroll: { speed: 0.5 },
        },
      }
    });

    // Mount with autoScroll extension
    if (window.splide && window.splide.Extensions) {
      logoSlider.mount(window.splide.Extensions);
    } else {
      logoSlider.mount(); // fallback if Extensions not available
    }
  }
});


// brand page Slider js
document.addEventListener('DOMContentLoaded', function () {
  const sliderEls = document.querySelectorAll('.our-brand-slider');

  sliderEls.forEach(function (sliderEl) {
    const ourBrand = new Splide(sliderEl, {
      // type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: '12px',
      // autoplay: true,
      // interval: 2000,
      // speed: 2000,
      pagination: false,
      arrows: true,
    });

    ourBrand.mount();
  });
});





// Transition Animations
// Fade-Right Animaiton

document.addEventListener("DOMContentLoaded", () => {
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("in-view");
                // Stop observing once animation is applied
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.2 });

    // Observe all animation classes
    const animatedEls = document.querySelectorAll(
        ".fade-right, .fade-left, .fade-bottom, .fade-top, .zoom-in, .zoom-out"
    );
    animatedEls.forEach(el => observer.observe(el));
});



// Features Tabing Accordion (Home Page)
var timer;
function loadtab() {
    timer = setTimeout(function () {
        var accordionItems = document.querySelectorAll('.home-tabing-sec .tab-card');
        var old_active = Array.prototype.indexOf.call(
            accordionItems,
            document.querySelector('.home-tabing-sec .tab-card.active-remove')
        );
        var new_index = parseInt(old_active) + 1;

        // remove old active
        document.querySelector('.home-tabing-sec .tab-card.active-remove')?.classList.remove('active-remove');
        document.querySelector('.home-tabing-sec .tab-content-wrapper .tab-content-inner.active-remove')?.classList.remove('active-remove');

        // add new active
        if (accordionItems[new_index]) {
            accordionItems[new_index].classList.add('active-remove');
            document.querySelectorAll('.home-tabing-sec .tab-content-wrapper .tab-content-inner')[new_index].classList.add('active-remove');
        } else {
            accordionItems[0].classList.add('active-remove');
            document.querySelectorAll('.home-tabing-sec .tab-content-wrapper .tab-content-inner')[0].classList.add('active-remove');
        }

        clearTimeout(timer);
        loadtab();
    }, 8000);
    return false;
}

// common function → activate tab
function activateTab(card) {
    const items = document.querySelectorAll('.home-tabing-sec .tab-card');
    const accordionImg = document.querySelectorAll('.home-tabing-sec .tab-content-wrapper .tab-content-inner');

    items.forEach(item => item.classList.remove('active-remove'));
    accordionImg.forEach(item => item.classList.remove('active-remove'));

    card.classList.add('active-remove');
    const index = Array.prototype.indexOf.call(items, card);
    accordionImg[index].classList.add('active-remove');

    clearTimeout(timer);
    loadtab();
}
// Click → activate
// document.addEventListener('click', function (event) {
//     const tabCard = event.target.closest('.home-tabing-sec .tab-card');
//     if (tabCard) {
//         activateTab(tabCard);
//     }
// });

// // Hover → activate (new)
// document.addEventListener('mouseenter', function (event) {
//     const tabCard = event.target.closest('.home-tabing-sec .tab-card');
//     if (tabCard) {
//         activateTab(tabCard);
//     }
// }, true);

function bindTabEvents(sectionSelector) {
    document.addEventListener('click', function (event) {
        const tabCard = event.target.closest(sectionSelector + ' .tab-card');
        if (tabCard) activateTab(tabCard);
    });
    document.addEventListener('mouseenter', function (event) {
        const tabCard = event.target.closest(sectionSelector + ' .tab-card');
        if (tabCard) activateTab(tabCard);
    }, true);
}

// Call for each section
bindTabEvents('.home-tabing-sec');
bindTabEvents('.new-tabing-sec');   // ✅ Add more as needed
bindTabEvents('.about-tabing-sec'); // Example



// First load
var wait_for_item = setInterval(function () {
    if (document.querySelector('.home-tabing-sec .tab-card.active-remove') === null) {
        clearInterval(wait_for_item);
        document.querySelectorAll('.home-tabing-sec .tab-card')[0].classList.add('active-remove');
        document.querySelectorAll('.home-tabing-sec .tab-content-wrapper .tab-content-inner')[0].classList.add('active-remove');
        loadtab();
        return false;
    }
}, 100); // check every 100ms





// marq slider

document.addEventListener('DOMContentLoaded', function () {
  const marqSlider = document.getElementById('marq-splide');

  if (marqSlider) {
    const splide = new Splide('#marq-splide', {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      autoWidth: true,
      autoScroll: {
        speed: 1,
      },
      pagination: false,
      arrows: false,
      gap: '1rem',
    });

    if (window.splide && window.splide.Extensions) {
      splide.mount(window.splide.Extensions);
    } else {
      splide.mount(); // fallback if Extensions are not loaded
    }
  }
});




// suport page - accordion section
function showTab(tabId) {
        const tabs = document.querySelectorAll('.tab-content');
        const buttons = document.querySelectorAll('.tab-btn');

        tabs.forEach(tab => tab.classList.remove('active'));
        buttons.forEach(btn => btn.classList.remove('active'));

        document.getElementById(tabId).classList.add('active');
        event.target.classList.add('active');
    }

document.querySelectorAll('.faq-question').forEach(div => {
    div.addEventListener('click', () => {
        const faqItem = div.parentElement;
        const answer = faqItem.querySelector('.faq-answer');
        const arrow = div.querySelector('.arrow');

        const isOpen = answer.classList.contains('open');

        if (isOpen) {
            // Close
            answer.style.maxHeight = answer.scrollHeight + 'px'; // set to current height
            setTimeout(() => {
                answer.style.maxHeight = "0px"; // then collapse
            }, 10);
            arrow.style.transform = 'rotate(0deg)';
            answer.classList.remove('open');
            div.classList.remove('active');
        } else {
            // Close all others first
            document.querySelectorAll('.faq-answer').forEach(ans => {
                ans.style.maxHeight = ans.scrollHeight + 'px';
                setTimeout(() => {
                    ans.style.maxHeight = "0px";
                }, 10);
                ans.classList.remove('open');
            });
            document.querySelectorAll('.arrow').forEach(arr => {
                arr.style.transform = 'rotate(0deg)';
            });
            document.querySelectorAll('.faq-question').forEach(q => {
                q.classList.remove('active');
            });

            // Open clicked one
            answer.style.maxHeight = "0px"; // reset
            setTimeout(() => {
                answer.style.maxHeight = answer.scrollHeight + "px";
            }, 10);
            arrow.style.transform = 'rotate(45deg)';
            answer.classList.add('open');
            div.classList.add('active');
        }
    });
});




// Counter JS
function animateCounter(counter) {
    const value = +counter.getAttribute("data-target");
    const speed = 40;

    const originalText = counter.textContent;
    const prefixMatch = originalText.match(/^[^0-9]*/);
    const suffixMatch = originalText.match(/[^0-9]*$/);

    const prefix = prefixMatch ? prefixMatch[0] : "";
    const suffix = suffixMatch ? suffixMatch[0] : "";

    let current = 0;
    const increment = value / speed;

    function updateCount() {
        if (current < value) {
            current = Math.ceil(current + increment);
            counter.textContent = prefix + current + suffix;
            requestAnimationFrame(updateCount);
        } else {
            counter.textContent = prefix + value + suffix;
        }
    }
    updateCount();
}

const section = document.getElementById("counter-section");
const counters = document.querySelectorAll(".counter");

if (section && counters.length > 0) {
    const observer = new IntersectionObserver(
        (entries) => {
            if (entries[0].isIntersecting) {
                counters.forEach((counter) => {
                    counter.textContent = counter.textContent.replace(/[0-9]+/, "0");
                    animateCounter(counter);
                });
            }
        },
        { threshold: 0.4 }
    );
    observer.observe(section);
}


//  // Tab Slider Js
// const tabbing = document.querySelectorAll(".tab");
// const tabContents = document.querySelectorAll(".tab-content");
// const splideEl = document.getElementById("splide");
// const splideList = document.querySelector("#splide .splide__list");

// let splide = null;
// let activeTabId = tabbing[0]?.getAttribute("data-tab") || null;

// function getAllImages() {
//     let allImages = [];
//     tabContents.forEach(c => {
//         const tabId = c.id;
//         const imgs = Array.from(c.querySelectorAll(".tab-items img"));
//         imgs.forEach(img => allImages.push({ tabId, img }));
//     });
//     return allImages;
// }

// function populateSlider(images) {
//     splideList.innerHTML = "";
//     images.forEach(item => {
//         const li = document.createElement("li");
//         li.classList.add("splide__slide");
//         li.dataset.tab = item.tabId;
//         li.appendChild(item.img.cloneNode(true));
//         splideList.appendChild(li);
//     });
// }

// function scrollToTab(tabId) {
//     const tab = Array.from(tabbing).find(t => t.getAttribute("data-tab") === tabId);
//     if (!tab) return;
//     const container = tab.parentElement;
//     const tabLeft = tab.offsetLeft;
//     const tabWidth = tab.offsetWidth;
//     const containerWidth = container.offsetWidth;
//     const scrollLeft = tabLeft - (containerWidth - tabWidth) / 2;
//     container.scrollTo({ left: scrollLeft, behavior: "smooth" });
// }

// function initSlider(startTab = activeTabId) {
//     const isMobile = window.matchMedia("(max-width: 767px)").matches;

//     if (!isMobile) {
//         splideEl.style.display = "none";
//         tabContents.forEach(c => c.style.display = c.id === startTab ? "block" : "none");
//         if (splide) {
//             splide.destroy();
//             splide = null;
//         }
//         return;
//     }

//     splideEl.style.display = "block";
//     tabContents.forEach(c => (c.style.display = "none"));

//     if (splide) {
//         splide.destroy();
//         splide = null;
//     }

//     const allImages = getAllImages();
//     let startIndex = 0;

//     if (startTab) {
//         const index = allImages.findIndex(item => item.tabId === startTab);
//         if (index >= 0) startIndex = index;
//     }

//     populateSlider(allImages);

//     if (allImages.length > 0) {
//         splide = new Splide("#splide", {
//             type: "loop",
//             perPage: 2,
//             perMove: 1,
//             focus: "center",
//             gap: "10px",
//             pagination: false,
//             arrows: true,
//             start: startIndex
//         }).mount();

//         splide.on("move", newIndex => {
//             const slide = splide.Components.Elements.slides[newIndex];
//             const tabId = slide.dataset.tab;
//             setActiveTab(tabId);
//             scrollToTab(tabId);
//         });
//     }
// }

// function setActiveTab(tabId) {
//     activeTabId = tabId;
//     tabbing.forEach(t => t.classList.remove("active"));
//     const tab = Array.from(tabbing).find(t => t.getAttribute("data-tab") === tabId);
//     if (tab) tab.classList.add("active");
// }

// tabbing.forEach(tab => {
//     tab.addEventListener("click", () => {
//         const tabId = tab.getAttribute("data-tab");
//         setActiveTab(tabId);
//         scrollToTab(tab);

//         const isMobile = window.matchMedia("(max-width: 767px)").matches;
//         if (isMobile) {
//             initSlider(tabId);
//         } else {
//             tabContents.forEach(c => c.style.display = c.id === tabId ? "block" : "none");
//         }
//     });
// });

// window.addEventListener("load", () => initSlider());
// window.addEventListener("resize", () => initSlider(activeTabId));
   

// Brand Page Hero Span Slider
document.addEventListener("DOMContentLoaded", function () {
    new Splide("#iconic-slider", {
      type: "fade",       // fade transition
      rewind: true,       // go back to first after last (acts like loop)
      perPage: 1,
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 2000,     // every 2s
      speed: 800,         // fade transition speed
      pauseOnHover: false,
      pauseOnFocus: false,
    }).mount();
  });